export const REVIEW_STATUS = {
  NOT_REVIEWED: 'not_reviewed',
  DRAFT: 'draft',
  APPROVED: 'approved',
}

export const INDEXATION_MODE = {
  AUTO: 'auto',
  NOINDEX: 'noindex',
}

export const REVIEW_STATUS_OPTIONS = [
  { label: 'Не перевірено', value: REVIEW_STATUS.NOT_REVIEWED },
  { label: 'Чернетка', value: REVIEW_STATUS.DRAFT },
  { label: 'Погоджено', value: REVIEW_STATUS.APPROVED },
]

export const INDEXATION_MODE_OPTIONS = [
  { label: 'Автоматично', value: INDEXATION_MODE.AUTO },
  { label: 'Не індексувати', value: INDEXATION_MODE.NOINDEX },
]

export const REVIEW_STATUS_CHIP_VARIANT = {
  [REVIEW_STATUS.NOT_REVIEWED]: 'neutral',
  [REVIEW_STATUS.DRAFT]: 'warning',
  [REVIEW_STATUS.APPROVED]: 'success',
}

export const INDEXATION_MODE_CHIP_VARIANT = {
  [INDEXATION_MODE.AUTO]: 'info',
  [INDEXATION_MODE.NOINDEX]: 'danger',
}

export function getSeoOptionLabel(options, value) {
  const match = options.find((option) => option.value === value)
  return match ? match.label : value || '—'
}

/** Full landing SEO defaults (globalCategories, brands). */
export const DEFAULT_LANDING_SEO = {
  schemaVersion: 1,
  title: null,
  metaDescription: null,
  ogTitle: null,
  ogDescription: null,
  ogImage: null,
  h1: null,
  introText: null,
  bottomText: null,
  reviewStatus: REVIEW_STATUS.NOT_REVIEWED,
  indexationMode: INDEXATION_MODE.AUTO,
  updated: null,
}

/** Compact product SEO defaults (products, outletProducts). */
export const DEFAULT_COMPACT_SEO = {
  schemaVersion: 1,
  title: null,
  metaDescription: null,
  ogTitle: null,
  ogDescription: null,
  ogImage: null,
  reviewStatus: REVIEW_STATUS.NOT_REVIEWED,
  indexationMode: INDEXATION_MODE.AUTO,
  updated: null,
}

/** @deprecated Prefer DEFAULT_LANDING_SEO — kept as alias for landing profile. */
export const DEFAULT_SEO = DEFAULT_LANDING_SEO

/** Soft UI recommendations only — never block save. */
export const SEO_SOFT_LIMITS = {
  title: 60,
  metaDescription: 160,
  ogTitle: 60,
  ogDescription: 160,
}
